import React from "react";
import { Crown } from "@phosphor-icons/react";

/** Small yellow "PREM" pill shown next to nicknames of Premier members. */
export const PremierBadge = ({ active = false }) => {
  if (!active) return null;
  return (
    <span
      data-testid="premier-badge"
      title="Premier member"
      aria-label="Premier member"
      className="inline-flex items-center gap-1 px-1.5 py-0.5 text-[9px] font-black uppercase tracking-wider rounded-sm bg-primary-yellow text-black leading-none"
    >
      <Crown size={9} weight="fill" /> Prem
    </span>
  );
};

export default PremierBadge;
